import React from 'react';

export const TermsOfUse = () => {
  return (
    <div className="bg-slate-50 dark:bg-slate-950 min-h-screen">
      <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 pt-24 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-3xl" />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 bg-blue-600/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6 border border-blue-500/30">
              <span className="text-blue-300 text-3xl font-bold">T</span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">Termos de Uso</h1>
            <p className="text-slate-300 text-lg max-w-xl mx-auto">
              Estes Termos regulam o acesso e a utilização do site da PCS Dutos e Exaustores.
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 p-8 md:p-10 -mt-8 relative z-20">
            <p className="text-slate-600 dark:text-slate-300 mb-8 leading-relaxed">
              Ao navegar, criar conta ou realizar compras, você concorda com estes termos.
            </p>

            <div className="space-y-6">
              {[ 
                {
                  title: '1. Quem somos',
                  body: 'A PCS comercializa produtos relacionados a dutos, exaustores e itens correlatos. As informações de contato e horários de atendimento estão disponíveis nas páginas do site.'
                },
                {
                  title: '2. Cadastro e conta',
                  body: 'Você é responsável por manter suas informações corretas e por proteger suas credenciais. Podemos suspender contas em caso de uso indevido, fraude ou violação destes Termos.'
                },
                {
                  title: '3. Compras, preços e pagamentos',
                  body: 'Os preços e condições podem ser alterados sem aviso prévio. As ofertas podem depender de disponibilidade de estoque. Em caso de erro de preço evidente, poderemos cancelar o pedido e comunicar você.'
                },
                {
                  title: '4. Entrega e prazos',
                  body: 'O prazo de entrega pode variar conforme localidade, forma de envio e disponibilidade.'
                },
                {
                  title: '5. Trocas e devoluções',
                  body: 'As regras de troca e devolução estão detalhadas na nossa Política de Devolução.'
                },
                {
                  title: '6. Propriedade intelectual',
                  body: 'Todo o conteúdo do site (textos, imagens, marca e layout) é protegido por direitos autorais e outros direitos de propriedade intelectual.'
                },
                {
                  title: '7. Limitação de responsabilidade',
                  body: 'A PCS não se responsabiliza por indisponibilidades temporárias do site, falhas de terceiros ou uso indevido da conta pelo usuário.'
                },
                {
                  title: '8. Alterações',
                  body: 'Podemos atualizar estes Termos a qualquer momento. Recomendamos revisar periodicamente.'
                },
                {
                  title: '9. Contato',
                  body: 'Em caso de dúvidas, fale conosco pelos canais de atendimento informados no site.'
                },
              ].map((item) => (
                <section
                  key={item.title}
                  className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700"
                >
                  <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">{item.title}</h2>
                  <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">{item.body}</p>
                </section>
              ))}
            </div>

            <p className="text-xs text-slate-400 dark:text-slate-500 mt-8 text-center">
              Última atualização: {new Date().toLocaleDateString('pt-BR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
